/**
 *
 * clip state selectors
 *
 */

import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { CLIP_KEY } from './clip-constants';

const selectClip = (state) => state[CLIP_KEY];

const makeSelectClipData = () =>
    createSelector(
        selectClip,
        (clipState) => clipState.data
    );

const makeSelectClipLoading = () =>
    createSelector(
        selectClip,
        (clipState) => clipState.loading
    );

const makeSelectClipError = () =>
    createSelector(
        selectClip,
        (clipState) => clipState.error
    );

const makeSelectClipId = () =>
    createSelector(
        selectClip,
        clipState => _get(clipState, 'data.id')
    );

export {
    selectClip,
    makeSelectClipData,
    makeSelectClipLoading,
    makeSelectClipError,
    makeSelectClipId
};
